module.exports = __webpack_public_path__ + "static/media/lesson-01.e062a2c4.svg";